import objectHandle, { ConfigurationOptions, EnvironmentType } from "../utilsTs/baseLib/objectHandle";

/** 环境变量 */
const env = process.env.REACT_APP_NODE_ENV as EnvironmentType;

/**
 * 获取配置
 * @param configName 配轩名称
 * @param options 选项
 * @returns 
 */
const getConfiguration = (configName: string, options?: ConfigurationOptions) =>
    objectHandle.getConfiguration(env, configName, options);

/** 服务器地址 */
const serverUrl = getConfiguration(
    'SERVERURL',
    {
        defaultValue: 'http://localhost:3007/test',
        configNamePrefix: 'REACT_APP_'
    });

/** 地址配置文件 */
const systematic = {
    /** 服务器地址 */
    serverUrl,
    /** 后端数据bmService */
    bmService: `${serverUrl}/bm/service`,
    /** 后端数据payService */
    payService: `${serverUrl}/pay/service`,
    /** 后端数据messageService */
    businessService: `${serverUrl}/business/service`,
    /** 后端数据mfService */
    mfService: `${serverUrl}/mf/service`
};

export default systematic;
